// src/components/EventMiniBlk.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import * as helpers from "../../helpers/helpers";
import * as paths from "../../constants/paths";
import Text from "./Text";
import http from "../../helpers/http";
import { doObjToFormData } from "../../helpers/helpers";
import { toast, ToastContainer } from "react-toastify";
import { TOAST_SETTINGS } from "../../utils/siteSettings";

const EventMiniBlk = ({ event }) => {
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const authToken = localStorage.getItem("authToken");

  const handleDeregister = () => {
    if (!authToken) {
      window.location.replace(paths.SITE_BASE_URL + "/signin");
      return;
    }

    setLoading(true);
    setDisabled(true);

    const formData = {
      token: authToken,
      event_id: event.id,
    };

    http
      .post("de-register-event", doObjToFormData(formData))
      .then((response) => {
        const data = response.data || response;
        // console.log("data", data);

        if (data.status === 1) {
          toast.success("You have been deregistered", TOAST_SETTINGS);
          setTimeout(() => {
            window.location.reload();
          }, 2000); 
        } else {
          toast.error("Technical Error", TOAST_SETTINGS);
          setLoading(false);
          setDisabled(false);
        }
      })
      .catch((err) => {
        console.error("Error", err);
        toast.error("Something went wrong", TOAST_SETTINGS);
        setLoading(false);
        setDisabled(false);
      });
  };

  return (
    <>
      <div className="event_mini_blk dash_event_blk">
        <ToastContainer />
        <div className="date date_event">
          <span>{helpers.onlyDayThreeletters(event.event_date)}</span>
          <strong>{helpers.onlyDateTwoletters(event.event_date)}</strong>
        </div>
        <div className="txt cstm_flex_new">
          <h4 className="title">
            <Link to={`/event-detail/${event.id}`}>
              <Text string={event.title} />
            </Link>
          </h4>
          <div className="time_date">
            <img
              src={paths.SITE_BASE_URL + "/images/new/calendar.svg"}
              alt=""
            />
            <span>
              {helpers.eventDateFormat(event.event_date)} @
              {helpers.eventTimeFormatNew(event.time_from)}
              {", "}
              {event.time_zone}
            </span>
          </div>
          <div className="cta cstm_mini_deregister">
            <div className="btn_blk">
              <button
                type="button"
                className="site_btn blank"
                onClick={handleDeregister}
                disabled={disabled}
              >
                {loading ? "Deregister" : "Deregister"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EventMiniBlk;
